// import React from 'react';
// import { Scale, Building2, FileCheck, Users, Gavel, Landmark, ShieldCheck, Briefcase } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';

// export const Services = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });

//   const services = [
//     {
      
//       title: 'القانون التجاري',
//       description:"صياغة العقود وتأسيس الشركات والاستشارات القانونية  وحل النزاعات بين الشركات",
//       icon: <Building2 className="w-12 h-12 text-navy-600" />
//     },
//     {
//       title: 'الدعاوى  العقارية   ',
//       description:"",

//       // description: 'قضايا الطلاق والنفقة وحضانة الأطفال وتقسيم الممتلكات وإبرام اتفاقيات ما قبل الزواج',
//       icon: <Users className="w-12 h-12 text-navy-600" />
//     },
//     {
//       title: ' تأسيس الشركات ',
//       description:"",

//       // description: 'الدفاع عن المتهمين في القضايا الجنائية وتمثيل الضحايا وتقديم المشورة القانونية',
//       icon: <Gavel className="w-12 h-12 text-navy-600" />
//     },
//     {
//       title: ' المستثمرين الاجانب و خدمات الإقامة المميزة',
// description:"",
//       // description: 'صياغة عقود البيع والشراء والإيجار وحل النزاعات العقارية وتسجيل الممتلكات',
//       icon: <Landmark className="w-12 h-12 text-navy-600" />
//     },
//     {
//       title: 'قانون العمل',
//       description: 'تمثيل أصحاب العمل والموظفين في نزاعات العمل وصياغة عقود العمل والاستشارات',
//       icon: <Briefcase className="w-12 h-12 text-navy-600" />
//     },
//     {
//       title: 'حقوق الملكية الفكرية',
//       description: 'تسجيل العلامات التجارية وبراءات الاختراع وحقوق التأليف والنشر والدفاع عنها',
//       icon: <ShieldCheck className="w-12 h-12 text-navy-600" />
//     },
//     {
//       title: 'الدعاوى المدنية',
//       description: 'تمثيل الموكلين في الدعاوى المدنية وقضايا المسؤولية التقصيرية والتعويضات',
//       icon: <FileCheck className="w-12 h-12 text-navy-600" />
//     },
//     {
//       title: 'الدعاوى الإدارية ',
//       description: 'تمثيل العملاء في إجراءات التحكيم الدولية وحل النزاعات التجارية عبر الحدود',
//       icon: <Scale className="w-12 h-12 text-navy-600" />
//     }
//   ];

//   return (
//     <section id="services" className="py-20 bg-white">
//       <div className="container mx-auto px-4 md:px-6">
//         <div 
//           ref={ref}
//           className={`text-center mb-16 transform transition-all duration-700 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4">خدماتنا القانونية</h2>
//           <div className="w-24 h-1 bg-navy-600 mx-auto mb-6"></div>
//           <p className="text-lg text-gray-700 max-w-3xl mx-auto">
//             نقدم مجموعة واسعة من الخدمات القانونية المتخصصة لتلبية احتياجات عملائنا من الأفراد والشركات
//           </p>
//         </div>
        
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {services.map((service, index) => (
//             <div 
//               key={index}
//               className={`bg-white p-6 rounded-lg shadow-card hover:shadow-card-hover transition-all duration-300 transform hover:-translate-y-2 border-b-4 border-navy-600 ${
//                 inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
//               }`}
//               style={{ 
//                 transitionDelay: `${index * 100}ms`,
//                 opacity: inView ? 1 : 0,
//                 transform: inView ? 'translateY(0)' : 'translateY(20px)'
//               }}
//             >
//               <div className="mb-5 flex justify-center">
//                 {service.icon}
//               </div>
//               <h3 className="text-xl font-bold text-navy-900 mb-3 text-center">{service.title}</h3>
//               <p className="text-gray-700 text-center">{service.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };


// import React from 'react';
// import { Scale, Building2, FileCheck, Users, Gavel, Landmark, ShieldCheck, Briefcase } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';

// export const Services = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });

//   // مصفوفة الخدمات بعد تنقيتها، ملء الفراغات، وتغيير فئات الألوان إلى الذهب الفاخر
//   const services = [
//     {
//       title: 'القانون التجاري',
//       description: 'صياغة العقود وتأسيس الشركات والاستشارات القانونية وحل النزاعات بين الشركات.',
//       icon: <Building2 className="w-12 h-12 text-amber-400 group-hover:text-amber-300 transition-colors duration-300" />
//     },
//     {
//       title: 'الدعاوى العقارية',
//       description: 'تمثيل الموكلين في منازعات الملكية، صياغة عقود التطوير العقاري، وحل إشكاليات الصكوك والفرز.',
//       icon: <Landmark className="w-12 h-12 text-amber-400 group-hover:text-amber-300 transition-colors duration-300" />
//     },
//     {
//       title: 'تأسيس الشركات',
//       description: 'تحديد الكيان القانوني الأمثل، صياغة قرارات الشركاء والأنظمة الأساسية، واستخراج التراخيص الاستثمارية.',
//       icon: <Gavel className="w-12 h-12 text-amber-400 group-hover:text-amber-300 transition-colors duration-300" />
//     },
//     {
//       title: 'المستثمرين الأجانب والإقامة المميزة',
//       description: 'تقديم الدعم القانوني الكامل لإصدار تراخيص وزارة الاستثمار وخدمات الإقامة المميزة للملاك والرواد.',
//       icon: <Users className="w-12 h-12 text-amber-400 group-hover:text-amber-300 transition-colors duration-300" />
//     },
//     {
//       title: 'قانون العمل',
//       description: 'تمثيل أصحاب العمل والموظفين في نزاعات العمل، صياغة اللوائح الداخلية وعقود العمل الاحترافية.',
//       icon: <Briefcase className="w-12 h-12 text-amber-400 group-hover:text-amber-300 transition-colors duration-300" />
//     },
//     {
//       title: 'حقوق الملكية الفكرية',
//       description: 'تسجيل وتوثيق العلامات التجارية، براءات الاختراع، وحمايتها من الانتهاك أو التقليد التجاري.',
//       icon: <ShieldCheck className="w-12 h-12 text-amber-400 group-hover:text-amber-300 transition-colors duration-300" />
//     },
//     {
//       title: 'الدعاوى المدنية',
//       description: 'تمثيل الموكلين أمام المحاكم العامة في قضايا الالتزامات المالية، المسؤولية التقصيرية، والتعويضات.',
//       icon: <FileCheck className="w-12 h-12 text-amber-400 group-hover:text-amber-300 transition-colors duration-300" />
//     },
//     {
//       title: 'الدعاوى الإدارية',
//       description: 'تمثيل الشركات والأفراد أمام ديوان المظالم في قضايا العقود الحكومية، وإلغاء القرارات الإدارية.',
//       icon: <Scale className="w-12 h-12 text-amber-400 group-hover:text-amber-300 transition-colors duration-300" />
//     }
//   ];

//   return (
//     //Changed background from bg-slate-900 to bg-white
//     <section id="services" className="py-24 bg-white border-b border-slate-800" dir="rtl">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
//         {/* الجزء العلوي للمكون */}
//         <div 
//           ref={ref}
//           className={`text-center mb-20 transform transition-all duration-1000 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
//             خدماتنا <span className="text-amber-400">القانونية</span>
//           </h2>
//           <div className="w-20 h-1 bg-gradient-to-r from-amber-500 to-amber-300 mx-auto mb-6 rounded-full"></div>
//           <p className="text-base md:text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
//             نقدم حزمة متكاملة من الخدمات والاستشارات القانونية النوعيّة والمصممة خصيصاً لتلبية متطلبات بيئة الأعمال المعاصرة.
//           </p>
//         </div>
        
//         {/* شبكة عرض الخدمات */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {services.map((service, index) => (
//             <div 
//               key={index}
//               className={`group bg-slate-950/40 p-8 rounded-2xl border border-slate-800/60 shadow-xl transition-all duration-500 transform hover:-translate-y-2 hover:bg-slate-950 hover:border-amber-500/30 hover:shadow-2xl hover:shadow-amber-500/5 flex flex-col justify-between ${
//                 inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
//               }`}
//               style={{ 
//                 transitionDelay: `${index * 75}ms`,
//               }}
//             >
//               <div>
//                 {/* الأيقونة المعززة بالحركة */}
//                 <div className="mb-6 inline-flex p-3 rounded-xl bg-slate-900 border border-slate-800 group-hover:border-amber-500/20 group-hover:bg-amber-500/5 transition-all duration-300">
//                   {service.icon}
//                 </div>
                
//                 {/* اسم الخدمة ووصفها */}
//                 <h3 className="text-xl font-bold text-white mb-3 group-hover:text-amber-400 transition-colors duration-300">
//                   {service.title}
//                 </h3>
//                 <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-6 font-light">
//                   {service.description}
//                 </p>
//               </div>

//               {/* رابط ذكي ينقل العميل تلقائياً لطلب استشارة في قسم اتصل بنا المحدث */}
//               <div className="pt-2">
//                 <a 
//                   href="#contact" 
//                   className="inline-flex items-center text-xs font-semibold text-amber-400 hover:text-amber-300 transition-colors duration-300 gap-1 group/link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     const target = document.querySelector('#contact');
//                     if (target) {
//                       const offset = document.querySelector('header')?.offsetHeight || 0;
//                       window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
//                     }
//                   }}
//                 >
//                   طلب استشارة 
//                   <span className="transform group-hover/link:-translate-x-1 transition-transform duration-300">←</span>
//                 </a>
//               </div>

//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };




// import React from 'react';
// import { Scale, Building2, FileCheck, Users, Gavel, Landmark, ShieldCheck, Briefcase } from 'lucide-react';
// import { useInView } from 'react-intersection-observer';

// export const Services = () => {
//   const { ref, inView } = useInView({
//     threshold: 0.1,
//     triggerOnce: true,
//   });

//   // مصفوفة الخدمات مع تعديل فئات الألوان للوضع الفاتح الفاخر
//   const services = [
//     {
//       title: 'القانون التجاري',
//       description: 'صياغة العقود وتأسيس الشركات والاستشارات القانونية وحل النزاعات بين الشركات.',
//       icon: <Building2 className="w-12 h-12 text-amber-600 group-hover:text-amber-700 transition-colors duration-300" />
//     },
//     {
//       title: 'الدعاوى العقارية',
//       description: 'تمثيل الموكلين في منازعات الملكية، صياغة عقود التطوير العقاري، وحل إشكاليات الصكوك والفرز.',
//       icon: <Landmark className="w-12 h-12 text-amber-600 group-hover:text-amber-700 transition-colors duration-300" />
//     },
//     {
//       title: 'تأسيس الشركات',
//       description: 'تحديد الكيان القانوني الأمثل، صياغة قرارات الشركاء والأنظمة الأساسية، واستخراج التراخيص الاستثمارية.',
//       icon: <Gavel className="w-12 h-12 text-amber-600 group-hover:text-amber-700 transition-colors duration-300" />
//     },
//     {
//       title: 'المستثمرين الأجانب والإقامة المميزة',
//       description: 'تقديم الدعم القانوني الكامل لإصدار تراخيص وزارة الاستثمار وخدمات الإقامة المميزة للملاك والرواد.',
//       icon: <Users className="w-12 h-12 text-amber-600 group-hover:text-amber-700 transition-colors duration-300" />
//     },
//     {
//       title: 'قانون العمل',
//       description: 'تمثيل أصحاب العمل والموظفين في نزاعات العمل، صياغة اللوائح الداخلية وعقود العمل الاحترافية.',
//       icon: <Briefcase className="w-12 h-12 text-amber-600 group-hover:text-amber-700 transition-colors duration-300" />
//     },
//     {
//       title: 'حقوق الملكية الفكرية',
//       description: 'تسجيل وتوثيق العلامات التجارية، براءات الاختراع، وحمايتها من الانتهاك أو التقليد التجاري.',
//       icon: <ShieldCheck className="w-12 h-12 text-amber-600 group-hover:text-amber-700 transition-colors duration-300" />
//     },
//     {
//       title: 'الدعاوى المدنية',
//       description: 'تمثيل الموكلين أمام المحاكم العامة في قضايا الالتزامات المالية، المسؤولية التقصيرية، والتعويضات.',
//       icon: <FileCheck className="w-12 h-12 text-amber-600 group-hover:text-amber-700 transition-colors duration-300" />
//     },
//     {
//       title: 'الدعاوى الإدارية',
//       description: 'تمثيل الشركات والأفراد أمام ديوان المظالم في قضايا العقود الحكومية، وإلغاء القرارات الإدارية.',
//       icon: <Scale className="w-12 h-12 text-amber-600 group-hover:text-amber-700 transition-colors duration-300" />
//     }
//   ];

//   return (
//     // تغيير الخلفية إلى رمادي فخم ناعم لإبراز الكروت البيضاء بنقاء
//     <section id="services" className="py-24 bg-slate-50 border-b border-slate-200" dir="rtl">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
//         {/* الجزء العلوي للمكون */}
//         <div 
//           ref={ref}
//           className={`text-center mb-20 transform transition-all duration-1000 ${
//             inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
//           }`}
//         >
//           <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-4">
//             خدماتنا <span className="text-amber-600">القانونية</span>
//           </h2>
//           <div className="w-20 h-1 bg-gradient-to-r from-amber-600 to-amber-400 mx-auto mb-6 rounded-full"></div>
//           <p className="text-base md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed font-light">
//             نقدم حزمة متكاملة من الخدمات والاستشارات القانونية النوعيّة والمصممة خصيصاً لتلبية متطلبات بيئة الأعمال المعاصرة.
//           </p>
//         </div>
        
//         {/* شبكة عرض الخدمات في الوضع الفاتح */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {services.map((service, index) => (
//             <div 
//               key={index}
//               className={`group bg-white p-8 rounded-2xl border border-slate-100 shadow-md transition-all duration-500 transform hover:-translate-y-2 hover:border-amber-500/30 hover:shadow-xl hover:shadow-amber-600/5 flex flex-col justify-between ${
//                 inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
//               }`}
//               style={{ 
//                 transitionDelay: `${index * 75}ms`,
//               }}
//             >
//               <div>
//                 {/* حاوية الأيقونة المتناسقة مع الخلفية الفاتحة */}
//                 <div className="mb-6 inline-flex p-3 rounded-xl bg-slate-50 border border-slate-100 group-hover:border-amber-500/20 group-hover:bg-amber-50 transition-all duration-300">
//                   {service.icon}
//                 </div>
                
//                 {/* اسم الخدمة ووصفها بوضوح عالي للمستخدم */}
//                 <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-amber-600 transition-colors duration-300">
//                   {service.title}
//                 </h3>
//                 <p className="text-slate-500 text-sm md:text-base leading-relaxed mb-6 font-light">
//                   {service.description}
//                 </p>
//               </div>

//               {/* زر طلب استشارة منسق للمود الفاتح */}
//               <div className="pt-2">
//                 <a 
//                   href="#contact" 
//                   className="inline-flex items-center text-xs font-bold text-amber-600 hover:text-amber-700 transition-colors duration-300 gap-1 group/link"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     const target = document.querySelector('#contact');
//                     if (target) {
//                       const offset = document.querySelector('header')?.offsetHeight || 0;
//                       window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
//                     }
//                   }}
//                 >
//                   طلب استشارة 
//                   <span className="transform group-hover/link:-translate-x-1 transition-transform duration-300">←</span>
//                 </a>
//               </div>

//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };


import React from 'react';
import { Scale, Building2, FileCheck, Users, Gavel, Landmark, ShieldCheck, Briefcase } from 'lucide-react';
import { useInView } from 'react-intersection-observer';

export const Services = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  // مصفوفة الخدمات بنمط الكحلي الدبلوماسي الفخم (Navy)
  const services = [
    {
      title: 'النظام التجاري',
      description: 'صياغة العقود وتأسيس الشركات والاستشارات القانونية وحل النزاعات بين الشركات.',
      icon: <Building2 className="w-12 h-12 text-indigo-950 group-hover:text-blue-700 transition-colors duration-300" />
    },
    {
      title: 'الدعاوى العقارية',
      description: 'تمثيل الموكلين في منازعات الملكية، صياغة عقود التطوير العقاري، وحل إشكاليات الصكوك والفرز.',
      icon: <Landmark className="w-12 h-12 text-indigo-950 group-hover:text-blue-700 transition-colors duration-300" />
    },
    {
      title: 'تأسيس الشركات',
      description: 'تحديد الكيان القانوني الأمثل، صياغة قرارات الشركاء والأنظمة الأساسية، واستخراج التراخيص الاستثمارية.',
      icon: <Gavel className="w-12 h-12 text-indigo-950 group-hover:text-blue-700 transition-colors duration-300" />
    },
    {
      title: 'المستثمرين الأجانب والإقامة المميزة',
      description: 'تقديم الدعم القانوني الكامل لإصدار تراخيص وزارة الاستثمار وخدمات الإقامة المميزة للملاك والرواد.',
      icon: <Users className="w-12 h-12 text-indigo-950 group-hover:text-blue-700 transition-colors duration-300" />
    },
    {
      title: 'قانون العمل والعمال',
      description: 'تمثيل أصحاب العمل والموظفين في نزاعات العمل، صياغة اللوائح الداخلية وعقود العمل الاحترافية.',
      icon: <Briefcase className="w-12 h-12 text-indigo-950 group-hover:text-blue-700 transition-colors duration-300" />
    },
    {
      title: 'حقوق الملكية الفكرية',
      description: 'تسجيل وتوثيق العلامات التجارية، براءات الاختراع، وحمايتها من الانتهاك أو التقليد التجاري.',
      icon: <ShieldCheck className="w-12 h-12 text-indigo-950 group-hover:text-blue-700 transition-colors duration-300" />
    },
    {
      title: 'الدعاوى المدنية',
      description: 'تمثيل الموكلين أمام المحاكم العامة في قضايا الالتزامات المالية، المسؤولية التقصيرية، والتعويضات.',
      icon: <FileCheck className="w-12 h-12 text-indigo-950 group-hover:text-blue-700 transition-colors duration-300" />
    },
    {
      title: 'الدعاوى الإدارية',
      description: 'تمثيل الشركات والأفراد أمام ديوان المظالم في قضايا العقود الحكومية، وإلغاء القرارات الإدارية.',
      icon: <Scale className="w-12 h-12 text-indigo-950 group-hover:text-blue-700 transition-colors duration-300" />
    }
  ];

  return (
    // خلفية فاتحة ناعمة جداً تبرز نقاء الكروت البيضاء
    <section id="services" className="py-24 bg-slate-50 border-b border-slate-200" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* الجزء العلوي للمكون */}
        <div 
          ref={ref}
          className={`text-center mb-20 transform transition-all duration-1000 ${
            inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-4">
            خدماتنا <span className="text-indigo-950">القانونية</span>
          </h2>
          {/* خط ديكوري بتدرج الكحلي والأزرق */}
          <div className="w-20 h-1 bg-gradient-to-r from-indigo-950 to-blue-500 mx-auto mb-6 rounded-full"></div>
          <p className="text-base md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed font-light">
            نقدم حزمة متكاملة من الخدمات والاستشارات القانونية النوعيّة والمصممة خصيصاً لتلبية متطلبات بيئة الأعمال المعاصرة.
          </p>
        </div>
        
        {/* شبكة عرض الخدمات بنمط الـ Navy Light */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className={`group bg-white p-8 rounded-2xl border border-slate-100 shadow-md transition-all duration-500 transform hover:-translate-y-2 hover:border-indigo-950/20 hover:shadow-xl hover:shadow-indigo-950/5 flex flex-col justify-between ${
                inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ 
                transitionDelay: `${index * 75}ms`,
              }}
            >
              <div>
<div className="flex items-center justify-center">
                {/* حاوية الأيقونة المتناسقة مع طابع الكحلي والرمادي الناعم */}
                <div className="mb-6  inline-flex p-3 rounded-xl bg-slate-50 border border-slate-100 group-hover:border-indigo-950/10 group-hover:bg-indigo-50/50 transition-all duration-300">
                  {service.icon}
                </div>
                </div>
                
                {/* العناوين والوصف */}
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-indigo-950 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-black text-sm md:text-base leading-relaxed mb-6 font-light">
                  {service.description}
                </p>
              </div>

              {/* رابط طلب استشارة كحلي أنيق */}
              <div className="pt-2">
                <a 
                  href="#contact" 
                  className="inline-flex items-center text-xs font-bold text-indigo-950 hover:text-blue-700 transition-colors duration-300 gap-1 group/link"
                  onClick={(e) => {
                    e.preventDefault();
                    const target = document.querySelector('#contact');
                    if (target) {
                      const offset = document.querySelector('header')?.offsetHeight || 0;
                      window.scrollTo({ top: target.offsetTop - offset, behavior: 'smooth' });
                    }
                  }}
                >
                  طلب استشارة 
                  <span className="transform group-hover/link:-translate-x-1 transition-transform duration-300">←</span>
                </a>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};